import React, { forwardRef } from 'react';
import ClearIcon from '../../Icons/ClearIcon/ClearIcon';
import styles from './AddTicketInput.module.scss';

const AddTicketInput = React.forwardRef((props, ref) => {
    const { disabled } = props;
    return (
        <div
            className={`${styles.inputGroup} ${disabled ? styles.disabled : ''}`}
            style={{ width: props.width }}
        >
            <input
                ref={ref}
                className={styles.input}
                disabled={disabled}
                type='text'
                placeholder={props.placeholder}
                value={props.inputValue}
                onChange={e => !disabled && props.onChange(e)}
                onKeyDown={props.onKeyPress}
                onFocus={e => e.target.select()}
            />
            <div className={styles.actions}>
                {props.inputValue ? (
                    <ClearIcon onClick={() => props.onChange({ target: { value: '' } })} />
                ) : null}
                <button
                    className={`icon-keyboard ${styles.keyboardButton}`}
                    onClick={() => props.setShowKeyboard()}
                />
            </div>
        </div>
    );
});

export default AddTicketInput;
